import { BoxType, UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { useMemo } from 'react';

export interface WeaponMarker {
  /** Absolute timestamp in ms on the timeline */
  absoluteTime: number;
  /** Frame second relative to the alarm video (0-4, or -1) */
  frame: number;
  /** The alarm this marker belongs to */
  alarmId: string;
}

/**
 * Extracts PERSON_WITH_WEAPON box data from alarms and returns
 * deduplicated weapon markers with absolute timeline positions.
 */
export function useWeaponMarkers(alarms: UnifiedAlarm[]): WeaponMarker[] {
  return useMemo(() => {
    const markers: WeaponMarker[] = [];
    const seen = new Set<string>();

    for (const alarm of alarms) {
      const boxes = alarm.media?.video?.boxes;
      if (!boxes || boxes.length === 0) continue;

      for (const box of boxes) {
        if (box.type !== BoxType.PERSON_WITH_WEAPON) continue;

        // Deduplicate by alarm + frame
        const key = `${alarm.id}-${box.frame}`;
        if (seen.has(key)) continue;
        seen.add(key);

        const frameOffset = box.frame === -1 ? 0 : box.frame * 1000;
        markers.push({
          absoluteTime: alarm.alarmStartTime + frameOffset,
          frame: box.frame,
          alarmId: alarm.id,
        });
      }
    }

    return markers;
  }, [alarms]);
}
